exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.icon[data-v-012f9c60] {\n  width: 0.75em;\n  width: 1cap;\n  height: 0.75em;\n  height: 1cap;\n}\n.with-icon[data-v-012f9c60] {\n  display: inline-flex;\n  align-items: baseline;\n}\n.with-icon .icon[data-v-012f9c60] {\n  margin-inline-end: 1rem;\n}\n", ""]);
